export default "__VITE_ASSET___nlcxC00__$_?src__"